export const AUTH_CALLBACK_PATH = 'callback';
export const ROOT_PATH = '/';
export const E_SIGN_MSG_ADVISOR_PATH = 'electronicsignature-advisor';
export const PRODUCT_PATH = 'product/:productCode';
export const CONTEXT_PATH = 'context/:id';
export const SIGNATURE_STATUS_PATH = 'signature/status/:status';
export const START_CONTEXT_PATH = 'start/:context';
export const START_CONTEXT_PRODUCT_PATH = 'start/:context/:product';
export const START_PATH = 'start';
export const SUBSCRIPTION_PATH = 'subscription';

/* Common */
export const SUBSCRIBER_PATH = 'subscriber';
export const OFFER_CUSTOMIZE_PATH = 'offer-customize';
export const QUOTE_CONFIRMATION_PATH = 'quote-confirmation';
export const DIRECT_DEBIT_PATH = 'direct-debit';
export const SPECIAL_CONDITIONS_PATH = 'special-conditions';
export const CONFIRMATION_PATH = 'confirmation';
export const ERROR_PATH = 'error';
export const ERROR_EMAIL_PATH = 'error-email';
export const MAINTENANCE_PATH = 'maintenance';
export const E_SIGN_MSG_PATH = 'e_sign_msg';
export const E_SIGN_MSG_STATUS_PATH = 'e_sign_msg/:status';
export const CONTRACT_VALIDATION_PATH = 'contract-validation';
export const CROSS_SELLING_C_PATH = 'cross-selling-c';
export const CROSS_SELLING_W_PATH = 'cross-selling-w';

/* Parcours */
export const INFORMATION_PATH = 'information';
